import { InstructorTableCellType } from '@/enums/InstructorTableCellType';
export default class InstructorTablePauseCell {
    cellType = InstructorTableCellType.PAUSE;
    hour;
    length = 1;
    row = null;
    constructor(row) {
        this.row = row;
    }
    toSaveObject() {
        const { row, ...saveObject } = this;
        return saveObject;
    }
}
